module.exports = __webpack_public_path__ + "9d04dc2ced252e6df6dd48713c04e5d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-night-lake.png
// module id = 1009
// module chunks = 0